import { getI18nTextIfExists } from "utils/i18n";

import { EntitleError } from "./entitleError";

export default class NewVersionError extends EntitleError {
  constructor() {
    super(getI18nTextIfExists("errors.newVersion.message") ?? "", getI18nTextIfExists("errors.newVersion.title") ?? "");
  }
}
